/* Used global Wordpress php variables to the ajax requests */
/* global phpvars */

/**
 * Vacancy Class
 */
export class Vacancy {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.header = document.querySelector( containerEl );
		if ( ! this.header ) {

			return false;

		}

		this.addEvents();

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		/* eslint-disable */
	    const template = document.querySelector( 'body.page-template-single-hroffice' );

	    if ( template ) {

	        const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const id = urlParams.get('id');
            const finalUrl = "?id=" + id;

            const links = document.querySelectorAll( '.language-overlay .wpml-ls-legacy-list-horizontal ul a' );

            links.forEach( ( link ) => {
                const href = link.getAttribute("href");
                link.href= href + finalUrl;
            } );

		}
        /* eslint-enable */

		const vacancyForm = document.querySelector( '.c-vacancy-overlay' );
		const vacancySimilar = document.querySelector( '.job-similar-offers' );

		if ( vacancyForm ) {

			const fileInput = document.querySelector( '.c-vacancy-overlay .wpcf7-file' );
			const fakeName = document.querySelector( '.c-vacancy-overlay .c-attachment-name' );

			if ( fileInput ) {

				fileInput.addEventListener( 'change', ( e ) => {

					const file = e.currentTarget.files[ 0 ];

					if ( file ) {

						let filename = e.currentTarget.files[ 0 ].name;

						if ( filename.substring( 3, 11 ) === 'fakepath' ) {

							filename = filename.substring( 12 );

						}

						fakeName.classList.add( 'is-active' );
						fakeName.querySelector( 'span' ).innerHTML = filename;

					}

				} );

			}

			if ( fakeName ) {

				fakeName.addEventListener( 'click', ( ) => {

					//fileInput.files[ 0 ] = null;
					fakeName.classList.remove( 'is-active' );
					fakeName.querySelector( 'span' ).innerHTML = '';

				} );

			}

			const buttonShowForm = document.querySelectorAll( '.js-button-apply' );
			const buttonHideForm = document.querySelector( '.c-vacancy-overlay .js-button-clear' );
			const vacancyContent = document.querySelector( '.block-jobs-content' );
			const vacancyCta = document.querySelector( '.block-cta' );
			const vacancySubject = document.querySelector( '.c-vacancy-overlay [name="your-subject"]' );
			const vacancyRecipient = document.querySelector( '.c-vacancy-overlay [name="your-recipient"]' );

			vacancySubject.setAttribute( 'value', vacancyForm.dataset.subject );
			vacancyRecipient.setAttribute( 'value', vacancyForm.dataset.recipient );

			if ( buttonShowForm.length > 0 ) {

				buttonShowForm.forEach( ( button ) => {

					button.addEventListener( 'click', ( e ) => {

						e.preventDefault();

						showForm();

					} );

				} );

			}

			/**
			 * Show Form
			 *
			 * @return {void}
			 */
			const showForm = () => {

				vacancyForm.style.display = 'block';
				vacancyContent.style.display = 'none';
				vacancyCta.style.display = 'none';

				if ( vacancySimilar ) {

					vacancySimilar.style.display = 'none';

				}

				const rect = document.querySelector( '.block-hero' ).offsetHeight;
				window.scrollTo( 0, rect );

			}

			buttonHideForm.addEventListener( 'click', ( e ) => {

				e.preventDefault();

				hideForm();

			} );

			/**
			 * Hide Form
			 *
			 * @return {void}
			 */
			const hideForm = () => {

				vacancyForm.style.display = 'none';
				vacancyContent.style.display = 'block';
				vacancyCta.style.display = 'block';
				if ( vacancySimilar ) {

					vacancySimilar.style.display = 'block';

				}

				const rect = document.querySelector( '.block-hero' ).offsetHeight;
				window.scrollTo( 0, rect );

			}

			/**
			 * Get Form
			 *
			 * @return {void}
			 */
			const getForm = () => {

				/* eslint-disable */
                fetch( phpvars.ajax_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams( {
                        action: 'get_application_by_id_and_language',
                        bn: phpvars.security,
                        vacancy_id: vacancyForm.dataset.vacancy,
                        language_id: vacancyForm.dataset.language,
                    } ),
                } ).then( ( response ) => {

                    return response.json();


                } ).then( ( response ) => {

                    //console.log(response);
                    if ( response.data.results.QuestionsList.AvQuestionList !== '' ) {

                        let template;
                        const wrapper = vacancyForm.querySelector('.c-form__questions');

                        const questions = response.data.results.QuestionsList.AvQuestionList;
                        //console.log(questions);

                        questions.forEach( ( question ) => {
                            //console.log(question.AnswerType);

                            if ( question.AnswerType === 1) {
                                const answers = question.AnswersList.AvAnswer;

                                template = "<div class='c-form__group c-form__select' data-QuestionId='" + question.QuestionId + "'><label>" + question.QuestionText + "*</label>";
                                template += "<span class='wpcf7-form-control-wrap'><select>";
                                answers.forEach( ( answer ) => {
                                    //console.log(answer.AnswerText);
                                    template += "<option data-AnswerId='" + answer.AnswerId + "' value='" + answer.AnswerText + "'>" + answer.AnswerText + "</option>";
                                });
                                template += "</span></select></div>";
                                wrapper.innerHTML += template;
                            }

                            if ( question.AnswerType === 4) {
                                template = "<div class='c-form__group' data-QuestionId='" + question.QuestionId + "'><label>" + question.QuestionText + "</label><textarea />";
                                wrapper.innerHTML += template;
                            }
                        });

                    }


                } ).catch( ( error ) => {

                    console.log(error);

                } );

                /* eslint-enable */

			}

			getForm();

			/* eslint-disable */
            let isSend = false;
			const buttonSubmit = vacancyForm.querySelector( '.wpcf7-submit' )

			buttonSubmit.addEventListener( 'click', ( e ) => {

			    if ( !isSend ) {
                    e.preventDefault();

                    console.log('clicked');

                    const cname = vacancyForm.querySelector('input[name="your-name"]').value;
                    const cemail = vacancyForm.querySelector('input[name="your-email"]').value;
                    const cmessage = vacancyForm.querySelector('textarea[name="your-message"]').value;
                    const cfile = vacancyForm.querySelector('input[name="your-file"]').files;

                    const cfields = document.querySelectorAll('.c-form__questions .c-form__group');
                    let qarray = [];
                    let cquestions = "";
                    if ( cfields.length > 0) {
                        cfields.forEach( ( field ) => {

                            const qid = field.dataset.questionid;
                            if ( field.querySelector('select') ) {
                                cquestions += qid + ":" +  field.querySelector('select').options[field.querySelector('select').selectedIndex].text + "|";
                            }
                            if ( field.querySelector('textarea') ) {
                                if ( field.querySelector('textarea').value === "") {
                                    field.querySelector('textarea').value = " ";
                                }
                                cquestions += qid + ":" +  field.querySelector('textarea').value + "|";
                            }
                        });
                    }

                    if ( (cname == null || cname === "") || (cemail == null || cemail === "") || (cmessage == null || cmessage === "") || (cfile.length === 0 ) ) {
                        console.log("Empty fields");
                    } else {
                        //console.log(cfile[0]);
                        readFile(cfile[0], cname, cemail, cmessage, cquestions);
                    }
                }
			} );


            function readFile(file, name, email, message, questions ) {
                const cname = name;
                const cemail = email;
                const cmessage = message;
                const cquestions = questions;

                const reader = new FileReader();

                reader.addEventListener('load', (event) => {

                    //console.log(event.target.result);

                    fetch( phpvars.ajax_url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams( {
                            action: 'set_application_by_id_v2',
                            bn: phpvars.security,
                            vacancy_id: vacancyForm.dataset.vacancy,
                            language_id: vacancyForm.dataset.language,
                            name: cname,
                            email: cemail,
                            message: cmessage,
                            file: event.target.result,
                            questions: cquestions,
                        } ),
                    } ).then( ( response ) => {

                        return response.json();


                    } ).then( ( response ) => {

                        console.log(response);
                        isSend = true;
                        buttonSubmit.click();

                        /*
                        if ( response.data.results !== '' ) {

                            //this.loopContainer.insertAdjacentHTML( 'beforeend', response.data.results );

                            console.log(response.data.results);

                        } else {



                        }

                         */


                    } ).catch( ( error ) => {

                        console.log(error);

                    } );

                });

                reader.readAsDataURL(file);

            }

            /* eslint-enable */

		}

		const breadcrumbs = document.querySelector( '.atlas-breadcrumbs' );

		if ( breadcrumbs && vacancyForm ) {

			const last = breadcrumbs.querySelector( '.breadcrumb_last' );

			if ( last ) {

				last.innerHTML = document.querySelector( '.block-hero__title' ).innerHTML;

			}

		}

	}

}
